import { IconButton } from '@mui/material';
import React from 'react';

import CloseIconButton from '/public/close-icon-button.svg';

interface MobileCloseButtonProps {
  setOpen: (value: boolean) => void;
}

export const MobileCloseButton = ({ setOpen }: MobileCloseButtonProps) => {
  return (
    <IconButton onClick={() => setOpen(false)} sx={{ p: 0 }}>
      <CloseIconButton />
    </IconButton>
  );
};
